import { Global, css } from '@emotion/react';
import { V2Brand, affiliatePalette, paletteVars } from '@repo/styles';
import { getServiceName } from '@repo/utils';

/**
 * v2 디자인시스템 CSS 변수(`--v2-*`)를 `:root`에 전역 주입한다. (리워드 웹)
 *
 * 리워드 테마(`affiliateThemeByService`)도 브랜드·v2 그룹을 `v2Color.*`(= `var(--v2-*)`)로 노출하고,
 * 웹과 공유하는 `@repo/ui` 컴포넌트(버튼·체크 아이콘·차트·FilterChip 등)도 v2 토큰을 참조한다.
 * 주입이 없으면 그 변수들이 해석되지 않아 색이 통째로 빠진다.
 *
 * 챗(`packages/chat-service`)과 달리 리워드는 다크모드가 없는 라이트 단일 표면이라
 * 브랜드×모드 팔레트가 아니라 라이트 고정 파생 팔레트(`affiliatePalette`)를 주입한다.
 *
 * 표면은 `'browser'` 고정 — 네이티브 화면과 1:1 대응하는 챗 탭과 달리 리워드는 인앱 웹뷰에서도
 * 페이지 배경을 네이티브에 맞출 이유가 없다(기본값은 UA 감지라 명시로 잠근다. cssVars.ts `V2Surface`).
 */
function V2BrandVarsGlobal() {
  const brand: V2Brand = getServiceName() === 'tingle' ? 'tingle' : 'bubblechat';

  return (
    <Global
      styles={css`
        :root {
          ${paletteVars(affiliatePalette(brand), brand, 'browser')}
        }
      `}
    />
  );
}

export default V2BrandVarsGlobal;
